import { useContext } from 'react';
import { MenuContext } from 'components/Product/MultiStep/Contexts';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useMenu = (): any => {
  return useContext(MenuContext);
};

export default useMenu;
